export const ProfileMessageMapping = {
    '10': 'Welcome to Plural! Complete your KYC to start accepting payments.',
    '20': 'Complete your KYC to start accepting payments.',
    '25': 'Complete your KYC to start accepting payments.',
    '30': 'Complete your KYC to start accepting payments.',
    '35': 'Complete your KYC to start accepting payments.',
    '40': 'Complete your KYC to start accepting payments.',
    '45': 'Complete your KYC to start accepting payments.',
    '50': 'Pending for KYC Approval.',
    '70': 'KYC has been successfully approved.',
    '80': 'Agreement has been sent to your email for digital signature.',
    '90': 'Thank you for signing the agreement. We are setting up your account.',
    '100': 'Congratulations, your Plural account has been activated. You can start accepting payment for active payment modes.'
  };

export const togglePath = '/toggle';
